import { usePage } from '../../contexts'
import { IPost } from '../../types'
import Credits from '../DateAndWriter/Credits'
import { Image } from '../Image/Image'
import Link from '../Link/Link'
import { utils } from '../Player/Helpers/utils'
import { Shave } from '../Shave/Shave'
import {
  Container,
  SecondaryTitle,
  TextContainer,
  Thumbnail,
  Title,
} from './MainPost.styles'

type Props = {
  post: IPost
  lifestyle?: boolean
}

export const MainPost = ({ post, lifestyle }: Props) => {
  const { imageObj, title, secondaryTitle, isBlank, id, link: postLink } = post

  const linkTarget = isBlank ? '_blank' : undefined
  const pageId = usePage()?.PageMeta.id

  const link = utils.addPageQueryParams(postLink, pageId, id)

  return (
    <Container>
      <Thumbnail href={link} target={linkTarget}>
        <Image image={imageObj} alt={imageObj ? title : title} />
      </Thumbnail>
      <TextContainer lifestyle={lifestyle}>
        <Link href={link} target={linkTarget}>
          <Shave maxLines={3}>
            <Title lifestyle={lifestyle}>{title}</Title>
          </Shave>
        </Link>
        <Shave maxLines={3}>
          <SecondaryTitle href={link} target={linkTarget} lifestyle={lifestyle}>
            {secondaryTitle}
          </SecondaryTitle>
        </Shave>
        <Credits credits={post} />
      </TextContainer>
    </Container>
  )
}
